import { Link, useNavigate } from "react-router-dom";
import ROLES from "../../utils/constants";
import { getDataFromJwt } from "../../utils/utility";

function VolunteerCard({ data }) {
	const roleid = getDataFromJwt("role");
	const navigate = useNavigate();

	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}

	return (
		<div
			onClick={() =>
				navigate("/admin/view-volunteer/" + data?.bat_volunteer_id)
			}
			className="profile-card"
		>
			<div className="d-flex gap-4">
				<img
					src="../assets/images/bat-img/volunteer-profile.svg"
					className="user-image"
				/>
				<div>
					<div className="d-flex gap-3 mb-15 align-items-center">
						<h5 className="tetx-blue-card">
							{data?.first_name} {data?.last_name}
						</h5>
						{data.status == "active" ? (
							<span className="activeVolunteer"></span>
						) : (
							<span className="inactiveVolunteer"></span>
						)}
					</div>
					<div className="d-flex gap-3 mb-10 font-14">
						<img src="../assets/images/bat-img/profile-email.svg" />
						<span>{data?.email}</span>
					</div>
					<div className="d-flex gap-3 mb-10 font-14">
						<img src="../assets/images/bat-img/phone.svg" />
						<span>{data?.mobile_number}</span>
					</div>
					{/* <div className="d-flex gap-3 font-14">
            <img src="../assets/images/bat-img/profile-location.svg" />
            <span className="fw-600">New York City, Central Park</span>
          </div> */}
				</div>
			</div>
		</div>
	);
}

export default VolunteerCard;
